import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ZapIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Frameworks',
    href: '#frameworks'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-xl border-b border-slate-200/50 shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-252" data-mp="9me3evgrg8xd">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between relative" data-id="element-253" data-mp="1l1uadm2lhmir">
        {/* Logo */}
        <div className="flex items-center space-x-2 z-10" data-id="element-254" data-mp="en167mavgvjv">
          <div className="w-6 h-6 overflow-hidden flex items-center justify-center" data-id="element-255" data-mp="epne5n1odd2m">
            <img src="https://cdn.magicpatterns.com/uploads/hRxQvVCJnxZUvLiFBQfhZy/Kinase_logo_—_transparent,_cropped.png" alt="Kinase Icon" className="h-full w-auto object-cover object-left" style={{
            filter: 'brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(500%) hue-rotate(130deg) brightness(95%) contrast(90%)'
          }} data-id="element-256" data-mp="jnf4icmo8r4p" />
          </div>
          <div className="flex items-baseline gap-2" data-id="element-257" data-mp="5n4hjkohfwot">
            <span className="text-xl font-bold text-slate-900 tracking-tight leading-none" data-id="element-258" data-mp="5opax6z299l3">
              Kinase
            </span>
            <span className="text-[10px] text-slate-400 font-normal italic tracking-wide" data-id="element-259" data-mp="39bfwpacvp5kd">
              (ky · nase)
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center justify-center space-x-8 absolute left-1/2 -translate-x-1/2" data-id="element-260" data-mp="2wcq3u3so923t">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-261" data-mp="3b35rrqch2o5o">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center space-x-4 z-10" data-id="element-262" data-mp="2df5gj15k2blb">
          <a href="https://app.getkinase.com" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-263" data-mp="2sbmqpp20dk6a">
            Sign in
          </a>
          <a href="https://app.getkinase.com" className="bg-teal-500 hover:bg-teal-400 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors flex items-center space-x-1.5" data-id="element-264" data-mp="7jb87nhjc30n">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-265" data-mp="a3h9toiofhe1" />
            <span data-id="element-266" data-mp="f3lp5b7um62o">Request free early access</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center" data-id="element-267" data-mp="14vus3ceyki0">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 p-2 transition-colors" aria-label="Toggle menu" data-id="element-268" data-mp="1671aax8u6ct">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-269" data-mp="xuwgfthhkkv3" /> : <MenuIcon className="w-6 h-6" data-id="element-270" data-mp="xwhalhzw21sf" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-lg py-4 px-6 flex flex-col space-y-4" data-id="element-271" data-mp="o3ib352usqu1">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 hover:text-slate-900 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-272" data-mp="1gle2xgbq6k80">
              {link.name}
            </a>)}
          <div className="pt-4 border-t border-slate-100 flex flex-col space-y-4" data-id="element-273" data-mp="3f37tr8iu2zrt">
            <a href="https://app.getkinase.com" className="text-base font-medium text-slate-600 hover:text-slate-900 text-center py-2" data-id="element-274" data-mp="3b25u4ql08lpb">
              Sign in
            </a>
            <a href="https://app.getkinase.com" className="bg-teal-500 hover:bg-teal-400 text-white px-5 py-3 rounded-lg text-sm font-medium w-full transition-colors flex items-center justify-center space-x-1.5" data-id="element-275" data-mp="6nfr4rl90u6b">
              <ZapIcon className="w-3.5 h-3.5" data-id="element-276" data-mp="3u0rw07ocigua" />
              <span data-id="element-277" data-mp="ue214oetcoiy">Request free early access</span>
            </a>
          </div>
        </div>}
    </header>;
}